{{ type ? (translateIndex + type | translate | uppercase) : '-' }}
